import { render } from "./pdftron.vue?vue&type=template&id=c5e5880e"
import script from "./pdftron.vue?vue&type=script&lang=js"
export * from "./pdftron.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__